import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifyError, notifySuccess } from '../../../helpers/utils';
import {
  processDataSourceQuery,
  addDataSource,
  getDataSource,
  updateDataSource,
} from './dataSource';

export const useDataSource = () => {
  const queryClient = useQueryClient();

  const processQuery = useMutation({
    mutationFn: processDataSourceQuery,
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({
        queryKey: ['processDataSourceQuery'],
      });
      notifySuccess(data.message || 'Query processed successfully');
    },
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  const addDataSourceQuery = useMutation({
    mutationFn: addDataSource,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['dataSource'],
      });
      notifySuccess('Saved Successfully!');
    },
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  const getDataSourceQuery = useMutation({
    mutationFn: getDataSource,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['dataSource'],
      });
    },
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  const updateDataSourceQuery = useMutation({
    mutationFn: updateDataSource,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['dataSource'],
      });
      notifySuccess('Updated Successfully!');
    },
    onError: (err) => {
      console.error(err);
      notifyError(err.message || 'An error occurred');
    },
  });

  return {
    processQuery,
    addDataSourceQuery,
    getDataSourceQuery,
    updateDataSourceQuery,
  };
};
